import { z } from 'zod';
import type { WifiApSettings } from '@ledium/types';
import { isValidSsid, isValidPassphrase } from './primitives.js';

export const DEVICE_NAME_MAX_LENGTH = 64;

// .transform trims whitespace before validation — a name of "  " fails min(1) after trim
export const setDeviceNameSchema = z.object({
    deviceName: z
        .string()
        .transform((v) => v.trim())
        .pipe(z.string().min(1).max(DEVICE_NAME_MAX_LENGTH))
});

export const setBooleanSchema = z.object({
    enabled: z.boolean()
});

export const setDateTimeSchema = z.object({
    timestamp: z.number().int().positive()
});

export const cloudRestoreSchema = z.object({
    filename: z.string().min(1)
});

export const wifiApSchema: z.ZodType<WifiApSettings> = z.object({
    ssid: z.string().refine(isValidSsid, { message: 'wifi_ap_ssid_invalid' }),
    passphrase: z.string().refine(isValidPassphrase, { message: 'wifi_ap_passphrase_invalid' })
});

export const DATE_FORMATS = ['YYYY-MM-DD', 'MM/DD/YYYY', 'DD/MM/YYYY'] as const;
export const TIME_FORMATS = ['24', '12'] as const;

export const setDateTimeFormatSchema = z.object({
    dateFormat: z.enum(DATE_FORMATS),
    timeFormat: z.enum(TIME_FORMATS)
});
